'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findRange = exports.init = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = exports.init = function init() {
  bindUIActions();
};

var findRange = exports.findRange = function findRange(width, height) {
  var size = parseFloat(width) * parseFloat(height);
  var range = void 0;

  (0, _jquery2.default)(_dom2.default.frameRange).each(function () {
    var rangeMin = parseFloat((0, _jquery2.default)(this).attr('data-frame-range-width'));
    var rangeMax = parseFloat((0, _jquery2.default)(this).attr('data-frame-range-height'));

    if (size >= rangeMin && size <= rangeMax) {
      range = (0, _jquery2.default)(this).attr('data-frame-range');
      return false;
    }
  });

  if (range != undefined) {
    (0, _jquery2.default)('.single-option-selector option[value="' + range + '"').prop('selected', true).trigger('change');
    if (!(0, _jquery2.default)(_dom2.default.atcBtn).hasClass('unavailable') && (0, _jquery2.default)(_dom2.default.frameFinish + '.selected').length > 0) {
      (0, _jquery2.default)(_dom2.default.atcBtn).prop('disabled', false).removeClass('disabled');
    } else {
      (0, _jquery2.default)(_dom2.default.atcBtn).prop('disabled', true).addClass('disabled');
    }
  } else {
    (0, _jquery2.default)('[data-custom-frame-error]').text('Frame is not available in this customization');
    (0, _jquery2.default)(_dom2.default.atcBtn).prop('disabled', true).addClass('disabled');
  }
};

var dropdownState = function dropdownState(state) {
  if (state == 'active') {
    (0, _jquery2.default)(_dom2.default.frameDropdown).addClass('is-active');
    (0, _jquery2.default)(_dom2.default.frameTrigger).addClass('is-active');
  } else {
    (0, _jquery2.default)(_dom2.default.frameDropdown).removeClass('is-active');
    (0, _jquery2.default)(_dom2.default.frameTrigger).removeClass('is-active');
  }
};

var featureImageUpdate = function featureImageUpdate(image) {
  (0, _jquery2.default)(_dom2.default.frameFeatureImage).find('img').attr('srcset', image);
  (0, _jquery2.default)(_dom2.default.frameFeatureImage).find('img').attr('src', image);
  (0, _jquery2.default)(_dom2.default.frameFeatureImage).find('source').attr('srcset', image);
};

var bindUIActions = function bindUIActions() {
  (0, _jquery2.default)(document).on('keyup', _dom2.default.customFrameInput, function () {
    var width = (0, _jquery2.default)(_dom2.default.customFrameWidth).val();
    var height = (0, _jquery2.default)(_dom2.default.customFrameHeight).val();

    findRange(width, height);
  });

  (0, _jquery2.default)(document).on('click', _dom2.default.frameSizeTrigger, function () {
    var width = (0, _jquery2.default)(this).attr('data-frame-width');
    var height = (0, _jquery2.default)(this).attr('data-frame-height');

    findRange(width, height);

    (0, _jquery2.default)(_dom2.default.customFrameHeight).val(height);
    (0, _jquery2.default)(_dom2.default.customFrameWidth).val(width);

    (0, _jquery2.default)(_dom2.default.frameSizeTrigger).removeClass('is-active');
    (0, _jquery2.default)(this).addClass('is-active');

    (0, _jquery2.default)(_dom2.default.frameTrigger).find('[data-frame-trigger-text]').text((0, _jquery2.default)(this).text());

    dropdownState('inactive');
  });

  (0, _jquery2.default)(document).on('click', _dom2.default.frameTrigger, function () {
    if (!(0, _jquery2.default)(this).hasClass('is-active')) {
      dropdownState('active');
    } else {
      dropdownState('inactive');
    }
  });

  (0, _jquery2.default)(document).on('click', _dom2.default.customFrameSizeTrigger, function () {
    dropdownState('inactive');
    (0, _jquery2.default)(_dom2.default.customFrame).addClass('is-active');
  });

  (0, _jquery2.default)(document).on('click', _dom2.default.customFrameCloseTrigger, function () {
    (0, _jquery2.default)(_dom2.default.customFrame).removeClass('is-active');
  });

  (0, _jquery2.default)(document).on('click', _dom2.default.frameFinish, function () {
    var featureImage = (0, _jquery2.default)(this).attr('data-feature-image');
    featureImageUpdate(featureImage);

    (0, _jquery2.default)(_dom2.default.frameFinish).removeClass('selected');
    (0, _jquery2.default)('.js-finish-panel-trigger').removeClass('selected');
    (0, _jquery2.default)(this).addClass('selected');

    var variantTitle = (0, _jquery2.default)(this).attr('data-variant-title');
    (0, _jquery2.default)('.single-option-selector option[value="' + variantTitle + '"').prop('selected', true).trigger('change');
    (0, _jquery2.default)(_dom2.default.productMeta).text(variantTitle);

    if ((0, _jquery2.default)(this).parents('[data-finish-panel]').length > 0) {
      var selectedImg = (0, _jquery2.default)(this).find('img').attr('src');
      var parent = (0, _jquery2.default)(this).parents('[data-finish-panel]').prev('.js-finish-panel-trigger');

      parent.addClass('selected');
      parent.find('img').attr('src', selectedImg);

      (0, _jquery2.default)('[data-finish-panel]').removeClass('is-active');
    }
  });
};